/*jshint esversion: 9 */
import React, { Component } from "react";
import { Fragment } from "react";
import { connect } from "react-redux";
// import { withStyles } from "@material-ui/core/styles";
import { doLog, hasValue } from "../../shared/utility";

import * as actions from "../../store/actions/index";
import classes from "../CrimeSubmission.css";
import Grid from "@material-ui/core/Grid";
import ManageRequiredField from "./ManageRequiredField";

// const styles = (theme) => ({
//   root: {
//     flexGrow: 1,
//     backgroundColor: theme.palette.background.paper,
//   },
//   textField: {
//     width: 250,
//   },
//   dense: {
//     marginTop: 19,
//   },
//   spacing: 1,
// });

class ManageRequiredFields extends Component {
  state = {
    searching: false,
    editMode: true,
    timeoutSecs: 10,
    arrayLoaded: false,
  };

  componentDidMount() {
    // if (doLog()) console.log("[ManageRequiredFields] componentDidMount state:", this.state);
    if (doLog()) console.log("[ManageRequiredFields] componentDidMount props:", this.props);
  }

  componentDidUpdate() {
    // if (doLog()) console.log("[ManageRequiredFields] componentDidUpdate");
    // if (doLog()) console.log("[ManageRequiredFields] componentDidUpdate state:", this.state);
    if (doLog()) console.log("[ManageRequiredFields] componentDidUpdate props:", this.props);
    if (!this.state.arrayLoaded) {
      this.setState({ arrayLoaded: true });
    }
  }

  handleNewManageRequiredField = (index, fields) => {
    // if (doLog()) console.log( "[ManageRequiredFields]handleNewManageRequiredField index:", index);
    // if (doLog()) console.log( "[ManageRequiredFields]handleNewManageRequiredField requiredFieldArray:", this.props.requiredFieldArray);
    if (doLog()) console.log(
      "[ManageRequiredFields]handleNewManageRequiredField fields:",
      fields
    );
    if (!this.state.arrayLoaded) this.props.onAddToRequiredFieldArray(fields);
  };

  render() {
    let formFields = null;

    // let list = this.props.requiredFieldList;
    // if (this.props.useDefaultList || !hasValue(list) || list.length === 0) {
    //   list = this.props.defaultRequiredFieldList; 
    // }

    let list = this.props.defaultRequiredFieldList;
    for (let i = 0; i < list.length; i++) {
      const array = list[i].data;
      if (array !== null) {
        const incidentType = this.props.incidentType;
        const sectionName = array.SECTIONNAME;
        const fieldName = array.FIELDNAME;
        // if (doLog()) console.log("[ManageRequiredFields] [" + i + "] incidentType:" + incidentType + " sectionName:" + sectionName + " fieldName:" + fieldName);

        if (hasValue(this.props.requiredFieldList)) {
          const selectedRow = this.props.requiredFieldList.find(
            (option) =>
              option.data.INCIDENTTYPE === incidentType &&
              option.data.FIELDNAME === fieldName &&
              option.data.SECTIONNAME === sectionName
          );
          if (hasValue(selectedRow)) {
            // if (doLog()) console.log("[ManageRequiredFields] [" + i + "]selectedRow:", selectedRow);
            list[i].data.REQUIRE = selectedRow.data.REQUIRE;
            // if (doLog()) console.log("[ManageRequiredFields] [" + i + "]new REQUIRE value:", list[i].data.REQUIRE);
          }
        }
      }
    }

    if (doLog()) console.log("[ManageRequiredFields] render list:", list);
    if (hasValue(list)) {
      let priorSectionName = "";
      const sectionArray = [];
      let fieldArray = [];
      let currentSectionName = "";
      for (let i = 0; i < list.length; i++) {
        const data = list[i].data;
        // if (doLog()) console.log("[ManageRequiredFields] data:", data);
        if (data.SECTIONNAME !== priorSectionName) {
          if (hasValue(priorSectionName)) {
            sectionArray.push(
              <Grid container item className={classes.FormFields} key={i}>
                <Grid item xs={12}>
                  <p className={classes.SeparateLabel}>{currentSectionName}</p>
                </Grid>
                {fieldArray}
              </Grid>
            );
            fieldArray = [];
          }
          priorSectionName = data.SECTIONNAME;
          currentSectionName =
            data.SECTIONNAME + " Section.  Check the fields that are required.";
        }
        fieldArray.push(
          <Grid item xs={4} key={i}>
            <ManageRequiredField
              item={data}
              index={i}
              onNewControl={this.handleNewManageRequiredField.bind(this)} 
            />
          </Grid>
        );
      }

      if (fieldArray.length > 0) {
        sectionArray.push(
          <Grid container item className={classes.FormFields} key={list.length}>
            <Grid item xs={12}>
              <p className={classes.SeparateLabel}>{currentSectionName}</p>
            </Grid>
            {fieldArray}
          </Grid>
        );
      }

      formFields = sectionArray;
    }

    return (
      <Fragment>
        <Grid item xs={12}>
          <hr />
        </Grid>
        {formFields}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  //   if (doLog()) console.log("[ManageRequiredFields] mapStateToProps state:", state);
  return {
    requiredFieldArray: state.trans.requiredFieldArray,
    requiredFieldList: state.trans.requiredFieldList,
    defaultRequiredFieldList: state.trans.defaultRequiredFieldList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAddToRequiredFieldArray: (item) =>
      dispatch(actions.addToRequiredFieldArray(item)),
  };
};

// export default withStyles(styles)(
//   connect(mapStateToProps, mapDispatchToProps)(ManageRequiredFields)
// );
export default connect(mapStateToProps, mapDispatchToProps)(ManageRequiredFields);
